<template>
  <div class="login-page">
    <!--container-->
    <div class="container py-5">
      <!--body-->
      <div class="logo-body">
        <div class="logo-img text-center mb-3">
          <img
            class="login-img"
            src="@/assets/logo_neu_darkgrey_blau_orangev2.png"
            alt=""
          />
        </div>
        <router-view />
      </div>
      <!--/body-->
    </div>
    <!--/container-->
    <!--  footer nafigation -->
    <footer-navigation />
    <!--  /footer nafigation -->
  </div>
</template>
<script>
import { HTTP } from '@/shared/http';

import FooterNavigation from '@/components/Login/FooterNavigation';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      intro: this.$t('login.intro'),
      loading: false,
      linkValidated: false,
      tabItems: [
        { code: 'Login', label: this.$t('login.tabLogin') },
        { code: 'Register', label: this.$t('register.tabRegister') },
      ],
      currentTabComponent: 'Login',
    };
  },
  props: {},

  components: {
    FooterNavigation,
  },

  computed: {
    ...mapGetters({
      isAuthenticated: 'isAuthenticated',
    }),

    cssClass() {
      if (this.linkValidated) return 'text-secondary';
      return null;
    },
  },

  methods: {
    // used to get localised WP links
    insertSubfolderIntoPath(path, subfolder) {
      const pathParts = path.split('/');
      pathParts.splice(1, 0, subfolder);
      const newPath = pathParts.join('/');
      return newPath;
    },

    getWordpressPath(to) {
      const userLocale = this.$i18n.locale;
      const path =
        'https://kulibri.com' + this.insertSubfolderIntoPath(to, userLocale);
      return path;
    },
    showWPPage(to) {
      const url = this.getWordpressPath(to);
      console.log('Open link in a new tab:', url);
      window.open(url, '_blank').focus();
    },
  },
  mounted() {
    this.$store.commit('setVisibleNav', false);

    // redirect logged in user to the dashboard
    console.log('signin - check for authenticated user:', this.isAuthenticated);
    if (this.isAuthenticated) {
      this.$router.push('/dashboard');
    }
  },
  created() {
    console.log(this.$route);

    if (this.$route.params.id && this.$route.params.hash) {
      //const apiUrl = process.env.VUE_APP_API_URI_SEGMENT;
      const url = `/email/verify/${this.$route.params.id}/${this.$route.params.hash}`;
      this.intro = this.$t('login.introConfirming');
      this.loading = true;
      HTTP.get(url)
        .then((response) => {
          console.log('link validation response', response);
          this.linkValidated = true;
          this.loading = false;
          this.intro = this.$t('login.introConfirmed');
        })
        .catch((error) => {
          console.log('link validation error', error);
          this.loading = false;
          this.intro = 'Email verification failed';
        });
    }
  },
};
</script>
<style lang="scss" scoped>
.login-page {
  height: 100vh;
  background-color: #f5f5f7;
  display: flex;
}

.logo-body {
  width: 355px;

  position: absolute;
  left: 50%;
  top: 10%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}

.login-img.img {
  width: 300px; /* you can use % */
  display: block;
}

.login-body.img {
  width: 300px; /* you can use % */
  display: block;
}

.login.form-control {
  font-size: 16px;
}

.bottom-navigation {
  position: absolute;
  bottom: 20px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
</style>
